import React, { useState, useEffect, useCallback } from 'react';
import { COLORS, SPACING } from '../styles/theme';
import { EventListing, getEventFeedListings, EventFeedMode } from '../lib/eventListings';
import { EventCard } from './EventCard';
import { EventComposer } from './EventComposer';
import { EventDetail } from './EventDetail';
import { loadOrCreateIdentity } from '../lib/identity';

const MODES: Array<{ key: EventFeedMode; label: string }> = [
  { key: 'local',     label: '◈ local' },
  { key: 'trending',  label: '▲ trending' },
  { key: 'following', label: '♥ following' },
  { key: 'fresh',     label: '↓ fresh' },
  { key: 'soon',      label: '⏱ soon' },
];

export function EventFeed() {
  const [mode, setMode] = useState<EventFeedMode>('local');
  const [listings, setListings] = useState<EventListing[]>([]);
  const [selected, setSelected] = useState<EventListing | null>(null);

  const identity = loadOrCreateIdentity();

  const reload = useCallback(() => {
    setListings(getEventFeedListings(mode, { userId: identity.userId }));
  }, [mode, identity.userId]);

  useEffect(() => { reload(); }, [reload]);

  if (selected) {
    return (
      <EventDetail
        listing={selected}
        onBack={() => { setSelected(null); reload(); }}
        onReload={reload}
      />
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div style={{ display: 'flex', gap: SPACING.xs, padding: SPACING.md, borderBottom: `1px solid ${COLORS.border}`, overflowX: 'auto', flexShrink: 0 }}>
        {MODES.map(m => (
          <button
            key={m.key}
            onClick={() => setMode(m.key)}
            style={{
              background: mode === m.key ? COLORS.accent : 'none',
              border: `1px solid ${mode === m.key ? COLORS.accent : COLORS.border}`,
              color: mode === m.key ? '#fff' : COLORS.text,
              padding: `${SPACING.xs} ${SPACING.md}`,
              cursor: 'pointer',
              fontFamily: '"IBM Plex Mono", monospace',
              fontSize: '11px',
              whiteSpace: 'nowrap',
            }}
          >
            {m.label}
          </button>
        ))}
      </div>

      <EventComposer onPublished={reload} />

      <div style={{ flex: 1, overflowY: 'auto' }}>
        {listings.length === 0 && (
          <div style={{ padding: SPACING.xl, color: COLORS.textMuted, fontFamily: '"IBM Plex Mono", monospace', textAlign: 'center', fontSize: '13px' }}>
            no events yet — list the first one
          </div>
        )}
        {listings.map(listing => (
          <EventCard
            key={listing.id}
            listing={listing}
            onClick={setSelected}
            onReload={reload}
          />
        ))}
      </div>
    </div>
  );
}
